import * as React from "react";
import {cx} from "emotion";

import "./header.scss";

import {cs}          from "@Common/react/chain-services";
import {negateState} from "@Common/react/negate-state";
import {upperCase1}  from "@Common/utils/strings";

import {SliderCheckbox} from "../../../../slider-checkbox/slider-checkbox";

import {socialToIcon} from "./social-ui";

export const Header = ({type, typeName=undefined, icon=undefined, login_url=undefined, unselected=undefined}) => cs(
    ({}) => (
        <div className={cx("header-5wn", {roundBottom: unselected && unselected.value})}>
            <div className="left">
                <a
                    className="logo"
                    href={login_url}
                    xd-qa-type="logo"
                    xd-qa-name={typeName ?? upperCase1(type)}
                >
                    {cs(
                        ["icon", (_, next) => next(icon ?? socialToIcon(type))],
                        ({icon}) => <>
                            {icon.background && (
                                <div className="background" style={{"--color": icon.background} as any} />
                            )}

                            <img
                                src={icon.src}
                                alt={type}
                                style={{"--scale": icon.scale ?? 1}as any}
                            />
                        </>
                    )}
                </a>
                <a
                    className="name"
                    href={login_url}
                    xd-qa-type="link"
                    xd-qa-name={"Login " + (typeName ?? upperCase1(type))}
                >
                    {typeName ?? upperCase1(type)}
                </a>
            </div>

            {unselected && (
                <div className="controls">
                    <div className="status" onClick={() => unselected.change(v=>!v)}>
                        {unselected.value ? (
                            "Sharing Disabled"
                        ) : (
                            "Sharing Enabled"
                        )}
                    </div>
                    {SliderCheckbox({
                        ...negateState(unselected),
                        dark: true,
                        xdQaName: (typeName ?? upperCase1(type)) + " " + (
                            unselected.value ? (
                                "Sharing Disabled"
                            ) : (
                                "Sharing Enabled"
                            )
                        )
                        // xdQaType: xdQaType + "_toggle",
                    })}
                </div>
            )}
        </div>
    ),
);
